export interface TextosDeNavegacion {
	/** El botón del selector sin nada elegido ni resumen. */
	seleccionarPlan: string;
	/** Nombre accesible del desplegable de planes. */
	selectorDePlan: string;
	/** La pantalla de aterrizaje multicuenta: fila del selector y botón cuando se está en ella. */
	resumenDePlanes: string;
	anadirPlan: string;
	/** La etiqueta de un plan que se está dando de alta, en lugar de su saldo. */
	enProceso: string;
	seleccionarEmpresa: string;
	selectorDeEmpresa: string;
	/** La etiqueta al lado de cada empresa. */
	admin: string;
	personal: string;
	/** El cambio a Admin con una empresa: «Admin {empresa}». */
	adminDeUnaEmpresa: string;
	/** Y con varias: «Admin {n} empresas». */
	adminDeVariasEmpresas: string;
	menuDeUsuario: string;
	configuracion: string;
	soporte: string;
	cerrarSesion: string;
	colapsarMenu: string;
	expandirMenu: string;
	/** Títulos de las hojas inferiores del móvil. */
	tusPlanes: string;
	tusEmpresas: string;
	tuCuenta: string;
	/** Nombre accesible del avatar del móvil. */
	cuentaYRol: string;
	/** El botón de la barra inferior con las secciones que no caben. */
	mas: string;
}

export const TEXTOS_DE_NAVEGACION: TextosDeNavegacion = {
	seleccionarPlan: 'Seleccionar plan',
	selectorDePlan: 'Selector de plan',
	resumenDePlanes: 'Resumen de planes',
	anadirPlan: 'Añadir plan',
	enProceso: 'En proceso',
	seleccionarEmpresa: 'Seleccionar empresa',
	selectorDeEmpresa: 'Selector de empresa',
	admin: 'Admin',
	personal: 'Personal',
	adminDeUnaEmpresa: 'Admin {empresa}',
	adminDeVariasEmpresas: 'Admin {n} empresas',
	menuDeUsuario: 'Menú de usuario',
	configuracion: 'Configuración',
	soporte: 'Soporte',
	cerrarSesion: 'Cerrar sesión',
	colapsarMenu: 'Colapsar menú',
	expandirMenu: 'Expandir menú',
	tusPlanes: 'Tus planes',
	tusEmpresas: 'Tus empresas',
	tuCuenta: 'Tu cuenta',
	cuentaYRol: 'Cuenta y rol',
	mas: 'Más'
};

/** Los de por defecto con los que se pasen encima. */
export const conTextos = (textos?: Partial<TextosDeNavegacion>): TextosDeNavegacion => ({
	...TEXTOS_DE_NAVEGACION,
	...textos
});

/**
 * Lo que lleva el menú de la cuenta además del cambio Personal / Admin. Sin pasarlo, las tres filas
 * se enseñan sin hacer nada (las historias); pasándolo, cada una sale solo si tiene a dónde llevar.
 */
export interface AccionesDeCuenta {
	onOpenSettings?: () => void;
	/** Soporte es una página aparte: se abre en otra pestaña. */
	supportHref?: string;
	onLogout?: () => void;
}
